/*
 * BaseModal.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Fri Feb 03 2023 mys Company
 */


import { createPortal } from "react-dom";

const BaseModal = ({ children, id, className }) => {
  return createPortal(
    <div
      className={`row fixed top-0 right-0 bottom-0 left-0 h-screen w-screen bg-gray-200/70 flex justify-center items-center ${className}`}
      id={id}
    >
      {children}
    </div>,
    document.getElementById("modal")
  );
};

export default BaseModal;
